var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/account-timeline/components/moved-note.tsx";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Account from 'soapbox/components/account';
import Icon from 'soapbox/components/icon';
import { HStack, Text } from 'soapbox/components/ui';

const MovedNote = _ref => {
  let {
    from,
    to
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "account__moved-note",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    className: "mb-2",
    alignItems: "center",
    space: 1.5,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/briefcase.svg'),
    className: "text-primary-600 dark:text-primary-400 flex-none",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "truncate",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    size: "sm",
    truncate: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "notification.move",
    defaultMessage: "{name} moved to {targetName}",
    values: {
      name: /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: from.display_name_html
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 29,
          columnNumber: 21
        }
      }),
      targetName: to.acct
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 11
    }
  })))), /*#__PURE__*/React.createElement(Account, {
    account: to,
    withRelationship: false,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 5
    }
  }));
};

export default MovedNote;